module.exports = __webpack_public_path__ + "img/LB000251.e2cba9ad.svg";